// i18n key resolution — shared by the client engine (I18nCore) and the server-side
// prerender materializer, so the lookup rules never diverge (golden rule #1).
// Browser-safe: no DOM, no Node APIs.

const HTML_PATTERN = /<[a-z][\s\S]*>/i;

/**
 * Resolve "a.b[0].c" against a dictionary; undefined if any hop is missing.
 * @param {object} dict
 * @param {string} key
 * @returns {*}
 */
export function resolveKey(dict, key) {
  const path = String(key)
    .replace(/\[(\d+)\]/g, '.$1')
    .split('.')
    .filter(Boolean);
  let current = dict;
  for (const part of path) {
    if (current === null || typeof current !== 'object') return undefined;
    current = current[part];
  }
  return current;
}

/** @param {string} value @returns {boolean} whether the value contains HTML markup. */
export function isHtmlValue(value) {
  return HTML_PATTERN.test(value);
}
